<template>
  <router-view />
</template>

<script>
export default {
  name: "gather",
};
</script>

